import { createStore } from 'owa-satcheljs';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { MailboxInfo } from 'owa-client-types';
import { getCopilotHeadlinesOptionStore } from '../utils/copilotHeadlinesStorageUtils';
import type { ExtractedTaskDetails } from '../types/ExtractedTaskDetails';

export type CatchUpTimeFrame = '3days' | '2days' | '24hours';

export enum TopicsGenerationState {
    NotStarted,
    InProgress,
    Completed,
    Failed,
}

export interface CopilotHeadlinesOptionStore {
    id: string;
    // Mutual exclusivity flags
    isHeadlinesEnabled: boolean;
    isCatchUpEnabled: boolean;
    // Headlines properties
    headlinesIncludeAllEmail: boolean;
    autoGenerateOnSessionStart: boolean;
    selectedHeadlineItemIds: string[];
    selectedHeadlineConversationIds: string[];
    // CatchUp properties
    catchUpIncludeAllEmail: boolean;
    shouldUsePrompt: boolean;
    shouldApplyPromptToIncomingMessages: boolean;
    timeFrame: CatchUpTimeFrame;
    needsReplyItemIds: string[];
    needsReplyConversationIds: string[];
    needsActionItemIds: string[];
    needsActionConversationIds: string[];
    needsScheduleItemIds: string[];
    needsScheduleConversationIds: string[];
    extractedTaskDetails: {
        [key: string]: ExtractedTaskDetails;
    };
}

interface CopilotHeadlinesOptionStoreMap {
    entries: Map<string, CopilotHeadlinesOptionStore>;
}

export const getCopilotHeadlinesStoreMap: () => CopilotHeadlinesOptionStoreMap =
    createStore<CopilotHeadlinesOptionStoreMap>('CopilotHeadlinesOptionStore', {
        entries: new Map<string, CopilotHeadlinesOptionStore>(),
    });

export default function getStore(mailboxInfo: MailboxInfo): CopilotHeadlinesOptionStore {
    const copilotHeadlinesStoreMap = getCopilotHeadlinesStoreMap();
    const name = getAccountKeyForMailboxInfo(mailboxInfo) + '_CopilotHeadlinesOptionStore';
    let cachedStore = copilotHeadlinesStoreMap.entries.get(name);

    if (!cachedStore) {
        copilotHeadlinesStoreMap.entries.set(name, getCopilotHeadlinesOptionStore(mailboxInfo));
        cachedStore = copilotHeadlinesStoreMap.entries.get(name);
    }

    if (!cachedStore) {
        throw new Error('Entry does not exist in the owa-copilot-headlines-option store');
    }

    return cachedStore;
}
